export const environment = {
  production: true,
  clientID: "Ae2QVIm8vNV_sSdN8k6Cwjd6bZX1hrO51LX1bB3WKMK-WaPrk7bPp1cSmHVNL3bSlbZywd5N8qrEBl_K", //production
  //clientID: "Ac4PhNZyyz-tvi-lWEU6R8UEfId5fUCLl6y26YecV87fEeOI_EpFutelFMFi0SdZEQN5_cYOA15JObsI&vault=true", // stagging
  // apiUrl: 'http://52.25.96.244:9001/'
  //apiUrl:'https://mscore.stagingsdei.com:9001/'
  //apiUrl: 'https://testapi.enl.solutions/' // Tests
  //apiUrl: 'https://shipping.enl.solutions/' // Production
  //  apiUrl: 'https://api.enl.solutions/' // Production
  //apiUrl: 'https://enlapiappwebprod.azurewebsites.net/'
  apiUrl: 'https://devapi.enl.solutions/' //dev
}